import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/sections/HeroSection";
import { PainSection } from "@/components/sections/PainSection";
import { AlignmentDiagramSection } from "@/components/sections/AlignmentDiagramSection";
import { FlywheelSection } from "@/components/sections/FlywheelSection";
import { RevenueGrowthSystemSection } from "@/components/sections/RevenueGrowthSystemSection";
import { WhatWeBuildSection } from "@/components/sections/WhatWeBuildSection";
import { FractionalSection } from "@/components/sections/FractionalSection";
import { HowWeIntegrateSection } from "@/components/sections/HowWeIntegrateSection";
import { ImpactSection } from "@/components/sections/ImpactSection";
import { InsightsPreviewSection } from "@/components/sections/InsightsPreviewSection";
import { FAQSection } from "@/components/sections/FAQSection";
import { TeamSection } from "@/components/sections/TeamSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="It's All About Growth | Fractional Revenue Leadership"
        description="Fractional growth and marketing leadership for mid-sized B2B service companies across the US and LATAM. Embedded operating partners, not vendors."
        path="/"
      />
      <Header />
      <main>
        <HeroSection />
        <AlignmentDiagramSection />
        <PainSection />
        <FlywheelSection />
        <RevenueGrowthSystemSection />
        <WhatWeBuildSection />
        <FractionalSection />
        <HowWeIntegrateSection />
        <ImpactSection />
        <InsightsPreviewSection />
        <FAQSection />
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
